exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-selection-div {\r\n    display: flex;\r\n    flex-grow: 1;\r\n    align-items: center;\r\n    justify-content: space-evenly;\r\n}\r\n", ""]);

// exports
